import emojiRegex from "emoji-regex";

export const checkTextHasNoEmoji: (
  template: any,
  output: any,
  currentOption: string,
) => boolean = (template: any, output: any, currentOption: string): boolean => {
  const regex: RegExp = emojiRegex();

  if (
    template.options[currentOption].type === "input" &&
    output.values[currentOption] &&
    output.values[currentOption][0] !== undefined
  ) {
    return output.values[currentOption].every(
      (text: string) => !regex.test(text),
    );
  }
  return true;
};
